import { useUserInfo } from 'pages/UserProvider';

export default function useHasPermission(): ({ roles }: { roles?: string[] }) => boolean {
  const { user } = useUserInfo();
  return ({ roles = [] }: { roles?: string[]; features?: string[] }): boolean => {
    return roles.includes(user?.roleName || '');
  };
}
